import React from "react";
import styled from "styled-components";

export const Line = React.memo(styled.div`
    height: 1px;
    border-bottom: 1px solid ${props => props.theme.greyLight};
`);